import { cloudChiprApi } from "../../../../services/cloudchipr.api";
import { RootState } from "../../../store";

const selector =
  cloudChiprApi.endpoints.getUsersMeOrganisationsCurrentBillingAccounts.select();

export const billingAccountsResponseSelector = (state: RootState) => {
  return selector(state);
};
